import { alchemy } from "@account-kit/infra";
import { cookieStorage, createConfig, CreateConfigProps } from "@account-kit/react";
import chains, { IxChain, primaryChain } from "@shared/src/config/chains";

const aChains: CreateConfigProps["chains"] = chains?.map(c => ({
  chain: {
    ...c,
  },
  transport: alchemy({ rpcUrl: c.rpcUrls.default.http[0] }),
}));
export const alchemyChains = aChains.map(c => c.chain) as IxChain[];

export const alchemyConfig = createConfig({
  transport: alchemy({ apiKey: process.env.ALCHEMY_API_KEY! }),
  chain: primaryChain,
  chains: [{ chain: primaryChain, policyId: process.env.ALCHEMY_API_KEY! }, ...aChains],
  sessionConfig: {
    expirationTimeMs: 1000 * 60 * 60 * 24, // 24 hours
  },
  ssr: true, // more about ssr: https://accountkit.alchemy.com/react/ssr
  storage: cookieStorage, // more about persisting state with cookies: https://accountkit.alchemy.com/react/ssr#persisting-the-account-state
  // enablePopupOauth: true, // must be set to "true" if you plan on using popup rather than redirect in the social login flow
});
